import React from 'react';

interface DuplicateConnectionOverlayProps {
  show: boolean;
}

export const DuplicateConnectionOverlay: React.FC<DuplicateConnectionOverlayProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 pointer-events-auto">
      <div className="bg-gray-900 border-2 border-red-500 rounded-lg p-8 text-center max-w-md">
        <div className="mb-6">
          <div className="inline-block">
            <div className="text-6xl">⚠️</div>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-red-400 mb-2 font-seurat">
          Duplicate Connection
        </h2>
        
        <p className="text-gray-300 mb-4 font-seurat">
          Your character has been logged in from another location. This session has been closed.
        </p>
        
        <p className="text-sm text-gray-400 mb-6 font-seurat">
          Only one session per character is allowed. Please close this tab and continue playing in your other session.
        </p>
        
        <div className="space-y-2">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded font-seurat transition-colors"
          >
            Reload Page
          </button>
          <button
            onClick={() => window.close()}
            className="w-full bg-gray-700 hover:bg-gray-600 text-gray-300 font-bold py-2 px-4 rounded font-seurat transition-colors"
          >
            Close Tab
          </button>
        </div>
      </div>
    </div>
  );
};
